import App from './App.svelte';

const app = new App({ // eslint-disable-line no-unused-vars
  target: document.body
});
